import { Reveal, Kicker } from "@/components/Reveal";
import { IMAGES } from "@/content";
import { Download } from "lucide-react";

export const VisionSection = ({ t }) => (
  <section id="vision" data-testid="vision-section" className="relative py-24 sm:py-32 px-6">
    <div className="max-w-6xl mx-auto">
      <div className="grid lg:grid-cols-5 gap-12 lg:gap-16">
        <div className="lg:col-span-3">
          <Reveal>
            <Kicker>{t.vision.kicker}</Kicker>
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#F4F0E6]">
              {t.vision.title}
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-10 text-base sm:text-lg text-[#A8A294] leading-relaxed">{t.vision.p1}</p>
          </Reveal>
          <Reveal delay={0.25}>
            <p className="mt-6 text-base sm:text-lg text-[#A8A294] leading-relaxed">{t.vision.p2}</p>
          </Reveal>
        </div>
        <Reveal delay={0.2} className="lg:col-span-2">
          <div className="overflow-hidden rounded-sm h-full min-h-[320px] border border-[#F4F0E6]/10">
            <img src={IMAGES.vision} alt="The Calanchi valley" className="w-full h-full object-cover" />
          </div>
        </Reveal>
      </div>

      <div className="mt-20">
        <Reveal>
          <h3 className="font-heading text-3xl sm:text-4xl tracking-tight text-[#F4F0E6]">{t.vision.principlesTitle}</h3>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-6 mt-10">
          {t.vision.pillars.map((p, i) => (
            <Reveal key={p.title} delay={0.1 + (i % 3) * 0.12}>
              <div data-testid={`vision-pillar-${i}`} className="border border-[#F4F0E6]/10 bg-[#1A1715] p-8 h-full">
                <span className="font-heading text-3xl text-[#D4A373]">0{i + 1}</span>
                <h3 className="text-lg text-[#F4F0E6] mt-4">{p.title}</h3>
                <p className="text-sm text-[#A8A294] mt-3 leading-relaxed">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="mt-24">
        <Reveal>
          <p className="text-xs tracking-[0.35em] uppercase text-[#8F9779] mb-4">{t.vision.visionsKicker}</p>
          <h3 className="font-heading text-3xl sm:text-4xl tracking-tight text-[#F4F0E6]">{t.vision.visionsTitle}</h3>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-6 mt-10" data-testid="vision-moods">
          {t.vision.visions.map((v, i) => (
            <Reveal key={v.img} delay={0.1 + i * 0.12} className={i === 1 ? "md:mt-10" : ""}>
              <figure data-testid={`vision-mood-${i}`} className="group relative">
                <div className="overflow-hidden rounded-sm border border-[#F4F0E6]/10">
                  <img src={v.img} alt={v.caption} className="w-full h-64 sm:h-72 object-cover hover:scale-105 transition-transform duration-[2s]" />
                </div>
                <a
                  href={v.img}
                  download
                  data-testid={`vision-mood-download-${i}`}
                  aria-label="Download image"
                  className="absolute top-3 right-3 p-2 rounded-full bg-[#0D0B0A]/60 backdrop-blur-md text-[#F4F0E6]/70 hover:text-[#D4A373] transition-colors"
                >
                  <Download size={14} />
                </a>
                <figcaption className="font-heading italic text-base text-[#A8A294] mt-3">{v.caption}</figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.3}>
          <p className="text-xs text-[#A8A294]/60 mt-6 tracking-wide">{t.vision.visionsNote}</p>
          <p className="text-sm text-[#A8A294] mt-4">
            {t.vision.archiveText}{" "}
            <a
              href={t.vision.archiveHref}
              download
              data-testid="vision-archive-download"
              className="inline-flex items-center gap-1.5 text-[#D4A373] hover:text-[#B87B41] transition-colors underline underline-offset-4"
            >
              <Download size={13} />
              {t.vision.archiveLabel}
            </a>
          </p>
        </Reveal>
      </div>

      <Reveal delay={0.2}>
        <p className="font-heading italic text-2xl sm:text-4xl text-center text-[#F4F0E6]/90 mt-24 max-w-3xl mx-auto leading-snug">
          {t.vision.quote}
        </p>
      </Reveal>
    </div>
  </section>
);
